type PlainObject = Record<string, unknown>;

const isPlainObject = (value: unknown): value is PlainObject =>
  typeof value === "object" && value !== null && !Array.isArray(value);

// Merges nested plain objects. Arrays and primitives from `override` win outright —
// only plain objects recurse. Used to layer chart option overrides onto the theme.
export function deepMerge<T extends PlainObject>(
  base: T,
  override?: PlainObject,
): T {
  if (!override) return base;
  const result: PlainObject = { ...base };
  for (const key of Object.keys(override)) {
    const baseValue = (base as PlainObject)[key];
    const overrideValue = override[key];
    result[key] =
      isPlainObject(baseValue) && isPlainObject(overrideValue)
        ? deepMerge(baseValue, overrideValue)
        : overrideValue;
  }
  return result as T;
}
